


















import PillContent from '@/components/pill/PillContent.vue';
import StaticContainer from './StaticContainer.vue';

export default {
  components: {
    PillContent,
    StaticContainer,
  },
};
